/* eslint-disable prettier/prettier */
import React from 'react';
import { useSeasons } from '../../../hooks/seasons';

function Standings({ season, setSeason }) {
  const [seasons] = useSeasons('desc');
  return (
    <div className="col-12 col-md-3 pe-md-1 mb-3 mb-md-0">
      <p className="heading-h6 mb-1">Säsong</p>
      <select
        value={season}
        onChange={(e) => setSeason(e.target.value)}
        className="select"
      >
        {seasons?.map((s) => (
          <option
            key={s.configSeasonStartYear}
            value={s?.configSeasonStartYear}
          >
            {Number(s?.configSeasonStartYear) < 1958
              ? `${s?.configSeasonStartYear}/${
                  Number(String(s?.configSeasonStartYear).slice(2)) + 1
                }`
              : `${s?.configSeasonStartYear}`}
          </option>
        ))}
      </select>
    </div>
  );
}
export default Standings;
